export const Banner20DataSource = {
  wrapper: { className: 'banner2' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        page: { className: 'home-page banner2-page kn9wmnm2duo-editor_css' },
        textWrapper: {
          className: 'banner2-text-wrapper kn9wo5uhif7-editor_css',
        },
        bg: { className: 'bg bg0 kn9wmowvkal-editor_css' },
        title: {
          className: 'banner2-title kn9wna3lrq-editor_css',
          children: "API Catalog",
        },
        content: {
          className: 'banner2-content',
          children: "Our APIs vary by market. To select your market, use the tab directly below.",
        },
      },
    ],
  },
};